module.exports = __webpack_public_path__ + "fonts/NotoSansCJKkr-Regular.f97524d1.woff2";